export default {
  deferredPayout: {
    id: 'seller-invoices-your_wallet-deferred_payout',
    defaultMessage: 'Deferred payout',
  },
  deferredPayoutInfoText: {
    id: 'seller-invoices-your_wallet-deferred_payout_info_text',
    defaultMessage:
      "This is the amount Back Market holds for any issues that could arise during each item's warranty period. Once an item's warranty periods ends, you'll receive the remaining amount.",
  },
  deferredPayoutLink: {
    id: 'seller-invoices-your_wallet-deferred_payout_link',
    defaultMessage: 'Read this article for more details',
  },
  noDeferredPayout: {
    id: 'seller-invoices-your_wallet-no_deferred_payout',
    defaultMessage: 'No deferred payout',
  },
}
